import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import TeamPage from "@/pages/TeamPage";
import ContactPage from "@/pages/ContactPage";
import PaymentStatusPage from "@/pages/PaymentStatusPage";
import { trackPageView } from "@/lib/firebase";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://finease-crm.vercel.app";

// Wrapper to force re-mount on route change
function ServiceDetailWrapper() {
  const { serviceSlug } = useParams();
  return <ServiceDetailPage key={serviceSlug} />;
}

function ScrollToTopOnRouteChange() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname, location.search]);

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  useEffect(() => {
    // Fallback: if PayU fails to return to status page, verify using last saved txnid.
    const lastTxnId = localStorage.getItem("finease_last_txnid");
    if (!lastTxnId) return;

    const isStatusPage = location.pathname.startsWith("/payment/");
    if (isStatusPage) return;

    fetch(`${API_BASE_URL}/api/payments/verify?txnid=${encodeURIComponent(lastTxnId)}`)
      .then((res) => res.json())
      .then((data) => {
        const status = String(data?.status || "").toLowerCase();
        if (status === "paid" || status === "failed") {
          localStorage.removeItem("finease_last_txnid");
        }
      })
      .catch(() => {
        // Silent fallback; status page has explicit error UI.
      });
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <BrowserRouter>
        <ScrollToTopOnRouteChange />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:serviceSlug" element={<ServiceDetailWrapper />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/payment/success" element={<PaymentStatusPage status="success" />} />
          <Route path="/payment/failure" element={<PaymentStatusPage status="failure" />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
